import { ToBoolean } from '../../..';

export class GetOneCourseQueryParamsDto {
  withAppointments: boolean;
  onlyUpcoming: boolean;
}
